import React, { memo } from 'react'

import { graphql, Link } from 'gatsby'

import Img from '../components/Img'

const Logo = ({ slice, context }) => {
  const logoImage = slice.primary.logo

  return (
    <Link
      to={`/${context.lang}`}
      className="logo"
      aria-label={logoImage?.alt || 'Logo'}
    >
      <Img
        image={logoImage?.gatsbyImageData}
        alt={logoImage?.alt}
        className="app-logo"
      />
    </Link>
  )
}

export default memo(Logo)

export const query = graphql`
  fragment FooterDataBodyFooter on PrismicFooterDataBodyFooter {
    id
    primary {
      logo {
        alt
        copyright
        gatsbyImageData
      }
    }
  }
  fragment HeaderDataNavFooter on PrismicHeaderDataNavFooter {
    id
    primary {
      logo {
        alt
        copyright
        gatsbyImageData
      }
    }
  }
`
